import { createUseStyles } from 'react-jss'

import { LightTheme } from '../../theme'

export const useStyle = createUseStyles((theme: LightTheme) => ({
  container: {
    marginTop: 24
  },
  title: {
    width: '100%',
    padding: 5,
    textAlign: 'center',
    boxSizing: 'border-box'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 32,
    width: '100%',
    marginTop: 16
  },
  tile: {
    textAlign: 'center',
    textDecoration: 'none'
  },
  image: {
    aspectRatio: '1 / 1',
    backgroundColor: theme.colors.shadow,
    backgroundPosition: 'center',
    backgroundSize: 'cover'
  },
  name: {
    display: 'block',
    marginTop: 12
  },
  '@media screen and (min-width: 481px)': {
    title: {
      fontSize: 24,
      lineHeight: '32px'
    },
    name: {
      fontSize: 24,
      lineHeight: '32px'
    }
  },
  '@media screen and (max-width: 1024px)': {
    grid: {
      gridTemplateColumns: 'repeat(2, 1fr)'
    }
  },
  '@media screen and (max-width: 480px)': {
    grid: {
      gap: 16
    }
  }
}))
